import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { Section } from '../common/Section';
import { SectionObject } from '../common/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Data.translations.json';
import { InputData } from './input-data/InputData';
import { NotFound } from './NotFound';
import { DataSubjects } from './data-subject/DataSubjects';
import { Samples } from './sample/Samples';
import { OutputData } from './output-data/OutputData';
import { path } from '../paths';

const { addTranslations, Translation } = i18nNsFactory('data-dictionary');
addTranslations(translations);

export const dataSections: SectionObject[] = [
  {
    key: 'input-data',
    id: 'input-data-menu-item',
    label: <Translation>{(t) => t('menu.input-data')}</Translation>,
    route: {
      path: path.inputDataDirectory + '/*',
      element: <InputData basePath={path.inputDataDirectory} />,
    },
  },
  {
    key: 'output-data',
    id: 'output-data-menu-item',
    label: <Translation>{(t) => t('menu.output-data')}</Translation>,
    route: {
      path: path.outputDataDirectory + '/*',
      element: <OutputData basePath={path.outputDataDirectory} />,
    },
  },
  {
    key: 'data-subjects',
    id: 'data-subjects-menu-item',
    label: <Translation>{(t) => t('menu.data-subjects')}</Translation>,
    route: {
      path: path.dataSubjectDirectory + '/*',
      element: <DataSubjects basePath={path.dataSubjectDirectory} />,
    },
  },
  {
    key: 'samples',
    id: 'samples-menu-item',
    label: <Translation>{(t) => t('menu.samples')}</Translation>,
    route: {
      path: path.sampleDirectory + '/*',
      element: <Samples basePath={path.sampleDirectory} />,
    },
  },
  {
    key: 'redirect-to-first-section',
    id: 'redirect-to-first-section-menu-item',
    route: {
      path: '/',
      element: <Navigate to="data-subjects" replace />,
    },
    hiddenFromMenu: true,
  },
  {
    key: 'not-found',
    id: 'not-found-menu-item',
    route: {
      path: '*',
      element: <NotFound />,
    },
    hiddenFromMenu: true,
  },
];

export interface DataProps {
  basePath?: string;
}

export const Data: FC<DataProps> = ({ basePath = '' }) => (
  <Section sections={dataSections} basePath={basePath} />
);
